import { Component, Input } from '@angular/core';
import { IDeviceContract } from '@nx-fe/services';

@Component({
  selector: 'app-card-memory',
  templateUrl: './card-memory.component.html',
  styleUrls: ['./card-memory.component.scss'],
})
export class CardMemoryComponent {
  @Input() device: IDeviceContract;
}
